/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__favorite_limit_reached__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Favoriten anzeigen`
};

const en_bookmark__favorite_limit_reached__cta = /** @type {(inputs: {}) => string} */ () => {
	return `See your favourites`
};

const es_bookmark__favorite_limit_reached__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Ver favoritos`
};

const fr_bookmark__favorite_limit_reached__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Voir les favoris`
};

const it_bookmark__favorite_limit_reached__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Vai ai preferiti`
};

const nl_bookmark__favorite_limit_reached__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijk favorieten`
};

const pt_bookmark__favorite_limit_reached__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Ver favoritos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached__cta = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__favorite_limit_reached__cta(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__favorite_limit_reached__cta", locale)
	if (locale === "de") return de_bookmark__favorite_limit_reached__cta(inputs)
	if (locale === "en") return en_bookmark__favorite_limit_reached__cta(inputs)
	if (locale === "es") return es_bookmark__favorite_limit_reached__cta(inputs)
	if (locale === "fr") return fr_bookmark__favorite_limit_reached__cta(inputs)
	if (locale === "it") return it_bookmark__favorite_limit_reached__cta(inputs)
	if (locale === "nl") return nl_bookmark__favorite_limit_reached__cta(inputs)
	return pt_bookmark__favorite_limit_reached__cta(inputs)
};